import { render } from "./day-three-lunch.vue?vue&type=template&id=6161aed4"
import script from "./day-three-lunch.vue?vue&type=script&lang=js"
export * from "./day-three-lunch.vue?vue&type=script&lang=js"
script.render = render

export default script